module.exports = __webpack_public_path__ + "img/portefeulle.d7a30645.png";